<template>
    <b-dropdown class="filter__doctor" variant="outline-orange" dropdown :text="selected">
        <b-dropdown-item @click="emitItemSelected(item)" v-for="(item, index) in items" :key="index">
            {{ item.text }}
        </b-dropdown-item>
    </b-dropdown>
</template>

<script>
  import * as DOCTOR from '@/store/constants/doctor';
  import {mapGetters, mapActions} from 'vuex';

  export default {
    data() {
      return {
        selected: 'All Doctors'
      }
    },

    computed: {
      ...mapGetters({
        doctors: DOCTOR.GET_DOCTOR_LIST
      }),
      items() {
        let data = [];

        window._.map(this.doctors.data, (item) => {
          data.push({
            value: item.id,
            text: `${item.last_name}, ${item.first_name}`
          })
        });

        return [{value: 0, text: 'All Doctors'}, ...data];
      }
    },

    methods: {
      ...mapActions({
        getDoctors: DOCTOR.ACTION_LIST_DOCTORS
      }),
      /**
       * Emit item selected.
       *
       * @param item
       */
      emitItemSelected(item) {
        this.$emit('selected', item);
        console.log(item);
        this.selected = item.text;
      }
    },

    created() {
      this.getDoctors({
        order_by: [`last_name,asc`]
      });
    }
  }
</script>

<style lang="scss">
    .filter__doctor {
        .dropdown-menu {
            height: 300px;
            overflow: auto;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/Common/Filter/AppointmentDoctorFilter.vue